import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { styled } from "@mui/material/styles";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { AppDispatch, RootState } from "../../services/redux/store";
import { useSelector, useDispatch } from "react-redux";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { CircularProgress, Divider, Grid } from "@mui/material";
import ChevronsDown from "./../../assets/images/icons/chevrons-down.png";
import { StepIconProps } from "@mui/material/StepIcon";
import CheckIcon from "@mui/icons-material/Check";
import clipboardCheck from "./../../assets/icons/dynamicForm/clipboard-check.png";
import booksCheck from "./../../assets/icons/dynamicForm/book line.png";
import { setCompletedStep } from "../../services/redux/slices/stepperSlice";
import DynamicForm from "../../components/Form/StepperDyanmicForm/DynamicForm";
import CustomerPoster from "../../assets/images/cust_post.svg";
import { authStatusSelector } from "../../services/redux/slices/authSlice";

export interface StepConfig {
  label: string;
  FormComponent: React.ComponentType<{ onNext: () => void }>;
}
interface VerticalLinearStepperProps {
  steps: StepConfig[];
  /** Pass through to DynamicForm; use SUMMARY on application summary page */
  pageType?: string;
  module?: string;
}

// Custom dashed connector with custom colors for active/completed lines
const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 18,
    left: "calc(-50% + 18px)",
    right: "calc(50% + 18px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#D7D8DE",
      borderStyle: "dashed",
      borderTopWidth: "1px",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#D7D8DE",
      borderStyle: "dashed",
      borderTopWidth: "1px",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: "#D7D8DE",
    borderTopWidth: "0.88px",
    borderRadius: 1,
    borderStyle: "dashed",
  },
}));

const VerticalLinearStepper: React.FC<VerticalLinearStepperProps> = ({
  steps,
  pageType = "FORM",
  module,
}) => {
  const activeHorizontalIndex = useSelector(
    (state: RootState) => state?.stepper?.activeHorizontalIndex
  );
  const activeVerticalIndexVal = useSelector(
    (state: RootState) =>
      state?.stepper?.activeVerticalIndex?.[activeHorizontalIndex]
  )
  const currentVerticalStep: any = steps[activeVerticalIndexVal];
  console.log(steps,activeHorizontalIndex, "currentVerticalStepcurrentVerticalStep")
  const fields = currentVerticalStep?.fields || [];
  console.log(fields, "fieldsfields")
  console.log(activeVerticalIndexVal, "fieldsfields activeVerticalIndexValactiveVerticalIndexVal")
  console.log(steps, "fieldsfields activeVerticalIndexValactiveVerticalIndexVal")
  return (
    <>
      <div
        className={"card-contaner"}
        style={{
          paddingLeft: pageType === "SUMMARY" ? "0px" : "0px",
          paddingRight: pageType === "SUMMARY" ? "0px" : "0px",
          paddingTop: pageType === "SUMMARY" ? "4px" : "0px",
          paddingBottom: pageType === "SUMMARY" ? "4px" : "0px",
          ...(pageType === "SUMMARY"
            ? {
                backgroundColor: "transparent",
                boxShadow: "none",
              }
            : {}),
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Box
            sx={{
              flex: 1,
              p: pageType === "SUMMARY" ? 0 : undefined,
              pl: pageType === "SUMMARY" ? 0 : 2,
              pr: pageType === "SUMMARY" ? 0 : 2,
              pt: pageType === "SUMMARY" ? 0 : 0,
              pb: pageType === "SUMMARY" ? 0 : 0,
              mb: pageType === "SUMMARY" ? 0.5 : 2,
              mt: pageType === "SUMMARY" ? "2px" : "5px",
            }}
          >
            <DynamicForm
              fields={fields}
              pageType={pageType}
              module={module}
              currentVerticalStep={currentVerticalStep}
            />
          </Box>
        </Box>
      </div>
    </>
  );
};

export default VerticalLinearStepper;
